// API of the multi-tenant package "bankscan": Admin → Companies → Bank statement mailbox.
import { apiRequest } from '../api';

export type BankMailboxSource = 'setting' | 'env' | 'none';
export interface BankMailboxSettingsView {
  mailboxEmail: string;                                   // stored choice ('' = server environment)
  effective: { source: BankMailboxSource; email: string; ready: boolean; error: string };
  envMailbox: string;                                     // the environment's mailbox address, if any
  accounts: { email: string; name: string }[];            // connected mailboxes to choose from
  pdfPasswords: { count: number; source: BankMailboxSource; unreadable: boolean; envCount: number };
  ignoredAccounts: string;                                // stored list as typed ('' = server environment)
  ignoredEffective: { source: BankMailboxSource; count: number };
}
export interface BankMailboxSettingsSave {
  mailboxEmail?: string;
  ignoredAccounts?: string;
  pdfPasswords?: string[];                                // replace-all; [] removes the stored passwords
}

export const bankscanApi = {
  get: (): Promise<BankMailboxSettingsView> => apiRequest('GET', '/admin/bank-mailbox-settings'),
  save: (data: BankMailboxSettingsSave): Promise<BankMailboxSettingsView> => apiRequest('PUT', '/admin/bank-mailbox-settings', data),
};
